import './RealEstate.css';
import mountains from '../../assets/mountains.jpg';

function RealEstate() {
  return (
    <div id="real-estate">
        <div className='real-estate-container'>
            <div className='real-estate-header' style={{
                backgroundImage: `url(${mountains})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                width: '100%'
            }}>
                <h1>Real Estate</h1>
                <p>Exploring High-Value Developments in Scenic, Sustainable Locations</p>
            </div>
            <div className='real-estate-content'>
                <p>At <b>Solid Investment</b>, we are currently exploring an exclusive real estate project in one of Lebanon’s most sought-after green mountain areas. This venture envisions a <b>premium gated community</b> blending modern living with nature's serenity—designed to offer privacy, security, and a <b>high quality of life</b>.</p>
                <p>Our vision is to create a residential environment that prioritizes sustainability, landscape integration, and contemporary architecture. This project marks the beginning of our <b>real estate</b> vertical, where we aim to identify and invest in unique locations that promise long-term value and lifestyle appeal.</p>
                <p>More details coming soon as we finalize the concept and development roadmap.</p>
            </div>
        </div>
    </div>
  );
}

export default RealEstate;